
import { useState,useEffect } from 'react'
import './styles/NotifiTech.css'
import Action from '../Action'
import { useFetch } from '../../hooks/useFetch'
import Selector from '../Selector'
import LoadSimple from '../LoadSimple'
import {roles}  from '../generales/GroupsId';
import ModalSelectTech from './ModalSelectTech'
import Modal from "react-modal";
import Search from '../generales/Search'
import { lang } from '../generales/traduction'
import { capitalizeFirstLetter } from '../../utils/utils'
import Paginador from '../generales/Paginador'
const ModalSelectTechStyles = {  
  content: {
    top: "50%",
    left: "50%",
    background: "#ffffff !important",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    height: "60%",
    padding: "20px",
  },
};
const NotifiTech=({languaje,mode,server,setInternalError})=>{
  const [editActive, setEditActive] = useState(false);
  const [permisos,setPermisos]=useState([])
  const [dataRoles,setDataRoles]=useState({data:[],loading:true,error:''})
  const [dataReports,setDataReports]=useState({data:[],loading:true,error:''})
  const [dataTech,setDataTech]=useState({data:[],loading:true,error:''})
  const [RolData,setRolData]=useState({data:[],loading:true,error:''})

  const [SelectTechModalOpen, setSelectTechModalOpen] = useState(false);

  const [selectedUser,setSelectedUser]=useState({})
  const [selectedType,setSelectedType]=useState({})
  const limitList = 200;
  const [pageActual, setPageActual] = useState(1);
  const startLimit = limitList * pageActual - limitList;
  const [dataUsers, setDataUsers] = useState({
    data: [],
    loading: true,
    error: null,
  });
  const [searchResults, setSearchResults] = useState([]);
  const [searchResult, setSearchResult] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  var dataList = searchTerm === "" ? (dataRoles.data.length==0?[]:dataRoles.data.data) : searchResults;
  const [CreateCisModalOpen, setCreateCisModalOpen] = useState(false);
  const pages = parseInt(dataList.length / limitList) + 1;
  const SelectNotifications = (user,option) => {
    setSelectedUser(user)
    setSelectedType(option)
    setSelectTechModalOpen(true);
  };
  function closCreateServiceModal() {
   
    setSelectTechModalOpen(false);
  }
  const handleChangEdit = (element) => {
    
          setSelectTechModalOpen(true);
  };
  const addPermiso=(e)=>{
    if (permisos.includes(e)) {
        // Eliminar el valor si ya existe
        const nuevoArreglo = permisos.filter(valor => valor !== e);
        setPermisos(nuevoArreglo);
      } else {
        // Agregar el valor si no existe
        const nuevoArreglo = [...permisos, e];
        setPermisos(nuevoArreglo);
      }
    // const nuevoArreglo = [...permisos, e]
  }


  useEffect(()=>{
    if(editActive){}
    
},[RolData.data])

  const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);
  const [selectedCheckboxes2, setSelectedCheckboxes2] = useState([]);
  const [idUsers,setIdUsers]=useState([])
  const getRoles=()=>{
    setDataRoles({data:dataRoles.data,loading:true,error:''})
    const fetchDataPost = async () => {
      
   try {
     const response = await fetch(server.url+'/api/v1/cassia/user/notifications/', {
       method: 'GET',  
       headers: {
         'Content-Type': 'application/json',
         Authorization: `Bearer ${localStorage.getItem('access_token')}`,
       },
     });
     if (response.ok) {
       const data1 = await response.json();
       setIdUsers(data1.data.map(obj => obj.user_id))
       setDataRoles({data:data1,loading:false,error:''})
     } else {
       throw new Error('Error en la solicitud');
     }
   } catch (error) {
        setInternalError(true)
          setDataRoles({data:dataRoles.data,loading:false,error:''})
        
      }
    };

    fetchDataPost();
  }
  function existsCombination(userId, notificationTypeId) {
    // Encuentra el usuario con el user_id dado
    // console.log('user: '+userId+" notifi: "+notificationTypeId)
    const user = dataRoles.data.data.find(user => user.user_id === userId);
    // console.log(user)
    // Si el usuario no existe, retorna false
    if (!user) {
      return false;
    }

    // Encuentra si existe la combinación de notificationTypeId en user_notification_types
    const notificationTypeExists = user.user_notification_types.some(
      notification => notification.cassia_notification_type_id === notificationTypeId
    );

    return notificationTypeExists;
  }

  const getTech=()=>{
    setDataTech({data:dataTech.data,loading:true,error:''})
    const fetchDataPost = async () => {
      
   try {
     const response = await fetch(server.url+'/api/v1/cassia/user/notifications/techs', {
       method: 'GET',  
       headers: {
         'Content-Type': 'application/json',
         Authorization: `Bearer ${localStorage.getItem('access_token')}`,
       },
     });

     if (response.ok) {
       const data1 = await response.json();
       // setIdUsers(data1.data.map(obj => obj.user_id))
       // setDataRoles({data:data1,loading:false,error:''})
       // setSelectedCheckboxes(data1.data.filter(obj => obj["1"] === 1).map(obj => obj.user_id))
       // setSelectedCheckboxes2(data1.data.filter(obj => obj["6"] === 1).map(obj => obj.user_id))
       // setDataTech(data1)
       setDataTech({data:data1,loading:false,error:''})
     } else {
       throw new Error('Error en la solicitud');
     }
   } catch (error) {
        setInternalError(true)
        setDataTech({data:dataTech.data,loading:false,error:''})
        console.error(error);
      }
    };

    fetchDataPost();
  }

  const getReportesInfo=()=>{
    setDataReports({data:dataReports.data,loading:true,error:''})
    const fetchDataPost = async () => {
      
   try {
     const response = await fetch(server.url+'/api/v1/cassia/user/notifications/notification_types', {
       method: 'GET',  
       headers: {
         'Content-Type': 'application/json',
         Authorization: `Bearer ${localStorage.getItem('access_token')}`,
       },
     });

     if (response.ok) {
       const data1 = await response.json();

       setDataReports({data:data1,loading:false,error:''})
     } else {
       throw new Error('Error en la solicitud');
     }
   } catch (error) {
        setInternalError(true)
        setDataReports({data:dataReports.data,loading:false,error:''})
        console.error(error);
      }
    };

    fetchDataPost();
  }
  useEffect(()=>{
    setInternalError(false)
    getTech()
    getReportesInfo()
    getRoles()
  },[])

  const [checkboxStates, setCheckboxStates] = useState({});
  useEffect(() => {
    // Inicializa el estado con los user_id y cassia_notification_type_id de las opciones de la base de datos
    if(dataRoles.data.length!=0 && dataReports.data.length!=0 ){
      const initialCheckboxStates = {};
    dataRoles.data.data.forEach(user => {
    
        dataReports.data.data.forEach(opcion => {
          // console.log(existsCombination(user.user_id,opcion.cassia_notification_type_id))
          initialCheckboxStates[`${user.user_id}-${opcion.cassia_notification_type_id}`] = {'user_id':user.user_id,'type_id':opcion.cassia_notification_type_id,'check':existsCombination(user.user_id,opcion.cassia_notification_type_id)}; // o true, dependiendo del valor inicial que desees
        });
      
    });
    setCheckboxStates(initialCheckboxStates);
    }
  }, [dataRoles, ,dataTech,dataReports]);

  const handleCheckboxChange = (userId, cassiaNotificationTypeId) => {
    setCheckboxStates(prevState => ({
      ...prevState,
      [`${userId}-${cassiaNotificationTypeId}`]: {
        ...prevState[`${userId}-${cassiaNotificationTypeId}`],
        check: !prevState[`${userId}-${cassiaNotificationTypeId}`].check,
      },
    }));;
  };



  const [arraySave,setArraySet]=useState({users_ids:[],cassia_report_frequency_schedule_ids:[]})
  const guardar=()=>{
    const types=dataReports.data.data.map(obj=>obj.cassia_notification_type_id)
    var users=dataRoles.data.data.map(obj=>obj.user_id)

    var final_users=[]
    for(let i=0;i<users.length;i++){
     var final_types=[]
     for( let j=0;j<types.length;j++){
       if(checkboxStates[users[i]+"-"+types[j]].check){
         final_types.push(types[j])
       }
     }
     final_users.push(final_types)
    }


    const data={
     "user_ids": users,
     "cassia_notification_type_ids": final_users
   }
    setDataRoles({data:dataRoles.data,loading:true,error:''})

    const fetchDataPost = async () => {
      
   try {
     const response = await fetch(server.url+'/api/v1/cassia/user/notifications/', {
       method: 'PUT',  
       headers: {
         'Content-Type': 'application/json',
         Authorization: `Bearer ${localStorage.getItem('access_token')}`,
       },
       body: JSON.stringify(data),
     });
     if (response.ok) {
       
       const data1 = await response.json();
       // setLoading(false)
       // setUserData({name:"",description:"",permissions:""})
       // setPermisos([])
      
       getRoles()
      
       setDataRoles({data:dataRoles.data,loading:false,error:''})
      
       // console.log(data1);
     } else {
       throw new Error('Error en la solicitud');
     }
   } catch (error) {
        setInternalError(true)
          // setUserData({name:"",description:"",permissions:""})
          // setPermisos([])
          // setDataPermisos({data:dataPermisos.data,loading:false,error:''})
 
        console.error(error);
      }
    };

    fetchDataPost();
  }

  return (
    <>
      <div className='head-cis'>
   <div className='title-cis'>
               <Search
                   searchResults={searchResults}
                   setSearchResults={setSearchResults}
                   searchTerm={searchTerm}
                   setSearchTerm={setSearchTerm}
                   // onSearch={handleSearch}
                   dataObject={dataRoles.data.data}
                   setDataObject={setDataUsers}
                   searchResult={searchResult}
                   setSearchResult={setSearchResult}
                   languaje={languaje}
                 />
         <div className={"cont-result-registers"+mode}>
        
                 <p style={{  textAlign: "center" }}>
                   &nbsp;
                   {capitalizeFirstLetter(lang[languaje]['resultadosEncontrados'])+" (" +
                     dataList.length +
                     ") " 
                     }
                 </p> 
         </div>
         <div className="cont-buttons-panel">
                 
                   <Action
                   disabled={false}
                   origen="Azul"
                   titulo={""+capitalizeFirstLetter(lang[languaje]['guardar'])}
                   action={guardar}
                 />
                 
                
               </div>
               </div>
               
           </div>
      <div className='cont-cis'>
      <>
<div className="main-panel-cis">
<div className="compact-content-portafolio">
<div className={"content-portafolio-head"+mode}>
        
        
        </div>
  <div className="content-portafolio">
    

    <div className="cont-portafolio-table">
      <div className="content-card-portafolio" id="content">
        {/*  aqui inicia */}
<>
<div className='cont-table-portafolio  ' >
                            <div className={"head-table-portafolio"+mode}>
                            <div className="compact-head-table-portafolio">
                                {/* <div className='field-head-table-users field-acciones'>
                                    Acciones
                                </div> */}
                                <div className='field-head-table-users field-nombre' style={{width:'25%'}}>
                                    {capitalizeFirstLetter(lang[languaje]['usuarios'])}
                                </div>
                                <div className='field-head-table-users field-table' style={{width:'75%',justifyContent:'start'}}>
                                
                                 {(dataReports.loading)?'':
                                dataReports.data.data.map((element,index)=>(
                                  <div className='field-head-table-users field-nombre' style={{width:'15%'}}>
                                  <div className='headNotifiAdmi ' style={{fontSize:'x-small',width:'100%'}}>
                                  <div class="tooltiptextNotifi" >{element.description}</div>
                                  {element.name}
                                  </div>
                                 
                              </div>))
                                }
                              </div>
                                
                              </div> 
                                

                            </div>
                            <div className='body-table-portafolio' >
                            <div className='cont-row-user-list'>
                            {dataRoles.loading ? (
                              <div style={{ width: '100%', height: '95%', display: 'flex', justifyContent: 'center' }}>
                                <LoadSimple />
                              </div>
                            ) : (
                              // dataRoles.data.data.map((user, userIndex) => (
                                (dataList.map((user, userIndex) => (
                                <div className={"row-table-portafolio"+mode} key={userIndex} style={{}}>
                                  <div className='field-body-table-users field-nombre' style={{ width: '25%',borderRight:'solid 1px #d5d5d5'}}>
                                    {user.name}
                                  </div>
                                  <div style={{ width: '75%',display:'flex'}}>
                                    
                                    
                                    {(dataTech.loading || dataReports.loading || dataRoles.loading || Object.values(checkboxStates).length==0)?'':
                                // dataTech.data.data.map((tec,index)=>(
                                //   <div  className='field-body-table-users field-correo' style={{ width: '7%', fontWeight: 'bold' ,display:'block',borderRight:'solid 1px rgba(240, 248, 255, 0.473)'}}>
                                    dataReports.data.data.map((opcion, optionIndex) => ( 
                                        <div key={optionIndex} className='field-body-table-users field-correo' style={{ width: '15%', fontWeight: 'bold' ,
                                          borderRight: '1px solid #d5d5d5'}}>
                                        <input
                                          type='checkbox'
                                          className={`NotifiCheckBox noti1 `}
                                          checked={checkboxStates[`${user.user_id}-${opcion.cassia_notification_type_id}`]['check'] || false}
                                          onChange={() => handleCheckboxChange(user.user_id, opcion.cassia_notification_type_id)}
                                          // disabled={checkboxStates[`${user.user_id}-${opcion.cassia_notification_type_id}`]['check']}
                                        />
                                        {
                                          (checkboxStates[`${user.user_id}-${opcion.cassia_notification_type_id}`]['check'])?<div className='cont-img-field-acciones' style={{width:'50%'}}>
                                          <img className='img-field-acciones' src='/iconos/edit.png' title='Editar' name='Editar' action_id={opcion.cassia_notification_type_id}  style={{width:'40%'}} onClick={()=>{SelectNotifications(user,opcion)}}/>
                                      </div>:''
                                        }
                                      </div>
                                    
                                    ))
                                  
                                }
                                    
                                  </div>
                                  
                                </div>
                              )))
                            )}
                              
            </div>
                                
                            </div>
                        </div>
                           
</>

{/*  aqui termina */}         
      </div>
    </div>
  </div>
  <div className={"content-portafolio-footer"+mode}>
    <div className="cont-display-paginador">
              <Paginador  pages={pages}
                          pageActual={pageActual}
                          setPageActual={setPageActual}
                          mode={mode}></Paginador>
    </div>
    <div className="cont-display-paginador">
      <div className={"cont-half-display-paginador"+mode}>
                
            
      </div>
      <div className={"cont-half-display-paginador"+mode}>
      <p style={{  textAlign: "center" }}>
                      &nbsp;
                      {"(" +
                  (startLimit + 1) +
                  " - " +
                  (dataList.length >  parseInt(pageActual ) * parseInt(limitList)
                    ?  parseInt(pageActual ) * parseInt(limitList)
                    : dataList.length) +
                  ")  "+lang[languaje]['de']+" " +
                  dataList.length +
                  " "+lang[languaje]['resultados']}
                </p>
            
      </div>
    </div>  
              
  </div>
  </div>

</div>

</>
          
      </div>
      <Modal
      isOpen={SelectTechModalOpen}
      // isOpen={false}
      // onAfterOpen={afterOpenExeption}
      onRequestClose={closCreateServiceModal}
      style={ModalSelectTechStyles}
      contentLabel="Example Modal2"
      // shouldCloseOnOverlayClick={false}
      >
          <ModalSelectTech
        // devices={devices}
        closCreateServiceModal={closCreateServiceModal}
        server={server}
        selectedUser={selectedUser}
        selectedType={selectedType}
        dataTech={dataTech}
        setDataTech={setDataTech}
        getRoles={getRoles}
        languaje={languaje}
        mode={mode}
      ></ModalSelectTech>
      </Modal>
    </>
  );
}

export default NotifiTech